<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="notifications"
          :loading="loading"
          must-sort
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <td v-text="props.item.name" />
            <td v-text="props.item.channel" />
            <td v-text="props.item.title" />
            <td
              v-text="new Date(props.item.date.seconds * 1000).toLocaleString()"
            />
            <td class="justify-center layout px-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="copyNotification(props.item)"
                    v-on="on"
                    v-text="fa('copy')"
                  ></v-icon>
                </template>
                <span>Duplicate</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>

        <v-btn
          color="primary"
          dark
          class="mb-2"
          absolute
          bottom
          left
          fab
          large
          @click="addNotification"
        >
          <v-icon v-text="fa('plus')" dark></v-icon>
        </v-btn>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px">
      <v-form
        v-model="notificationFormValid"
        lazy-validation
        @submit.prevent
        autocomplete="off"
        ref="form"
      >
        <v-card>
          <v-card-title>
            <span class="headline">New notification</span>
          </v-card-title>

          <v-card-text v-if="newNotification">
            <v-text-field
              v-model="newNotification.name"
              :rules="[formRules.required]"
              label="Notification name"
              required
            />
            <v-text-field
              v-model="newNotification.title"
              :rules="[formRules.required]"
              label="Title (Android et watchOS)"
              required
            />
            <v-text-field
              v-model="newNotification.text"
              :rules="[formRules.required]"
              label="Text"
              required
            />
            <v-select
              v-model="newNotification.channel"
              :items="notificationChannels"
              :rules="[formRules.required]"
              item-text="title"
              item-value="id"
              attach
              label="Channel"
            />
            <ActionType v-model="newNotification.action.type" />
            <ActionLink
              v-model="newNotification.action.link"
              :type="newNotification.action.type"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="close" :disabled="loading">Cancel</v-btn>
            <v-btn
              color="primary"
              @click="save"
              :disabled="!notificationFormValid"
              type="input"
              :loading="loading"
              >Add notification</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import { db } from "../../plugins/firebase";
import ActionType from "../../components/ActionType";
import ActionLink from "../../components/ActionLink";
import {
  appConfig as appConfigConstant,
  eventHub
} from "../../config/constants";
const notificationsCollection = db.collection("notifications");

export default {
  name: "Notifications",
  components: { ActionType, ActionLink },
  data() {
    return {
      pagination: {
        sortBy: "date",
        rowsPerPage: -1,
        descending: true
      },
      loading: false,
      notificationFormValid: false,
      dialog: false,
      newNotification: null,
      notification: {
        name: null,
        title: null,
        text: null,
        channel: null,
        action: {
          type: "NONE"
        },
        click_action: "FLUTTER_NOTIFICATION_CLICK",
        language: null
      },
      notifications: [],
      notificationChannels: []
    };
  },
  async created() {
    const language = this.$route.params.language;
    this.$bind(
      "notifications",
      notificationsCollection.where("language", "==", language)
    );
    const appConfig = await db
      .collection("appConfigs")
      .doc(appConfigConstant)
      .get();
    const notificationChannels = appConfig.data().languages[language]
      .notificationChannels;
    this.notificationChannels = [
      {
        title: "All users",
        id: "all_users"
      },
      ...Object.keys(notificationChannels).map(id => ({
        title: notificationChannels[id].title,
        id
      }))
    ];
  },
  computed: {
    headers: () => [
      {
        text: "Name",
        value: "name"
      },
      { text: "Channel", value: "channel" },
      { text: "Title", value: "title" },
      { text: "Date", value: "date" },
      { text: "Actions", value: "action", sortable: false, width: "100px" }
    ]
  },
  methods: {
    addNotification() {
      this.newNotification = {
        ...this.notification,
        action: {
          type: null,
          link: {
            ...this.notification.action.link
          }
        }
      };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.newNotification = null;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        this.newNotification.language = this.$route.params.language;
        await this.$functions.httpsCallable("newNotification")(
          this.newNotification
        );
      } catch (error) {
        eventHub.$emit("message", "green");
      }
      this.loading = false;
      this.close();
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  }
};
</script>
